module.exports = __webpack_public_path__ + "static/media/Artikal5.0bbd74a2.png";